// extracted by mini-css-extract-plugin
module.exports = {"ValidOfferModal":"HideOffers_ValidOfferModal__2CCf1","secondButton":"HideOffers_secondButton__1Q7Il"};